import { useState } from 'react';
import { AssetDetails } from 'modules/queries/asset/useDetails';
import { BackupTypeProvider } from './context';
import AcronisBackupSettings from './Acronis';
import CloudBackupSettings from './Cloud';
import BackupTypeSelect from './BackupTypeSelect';

interface BackupTypeSwitchProps {
	assetDetails: AssetDetails;
	onDestroyAcronis: () => void;
	onDestroyCloudBackup: () => void;
	onClose: () => void;
}

const BackupTypeSwitch: React.FC<BackupTypeSwitchProps> = ({
	assetDetails,
	onDestroyAcronis,
	onDestroyCloudBackup,
	onClose,
}) => {
	const getInitialType = () => {
		if (assetDetails?.hasAcronis && assetDetails.acronisStatus === 'Active') {
			return 'AcronisBackup';
		}
		const backupPlan = assetDetails.featureDetails?.LiquidWebBackupPlan?.value;
		if (backupPlan && backupPlan !== 'None') {
			return 'CloudBackup';
		}
		return 'None';
	};

	const [type, setType] = useState(getInitialType());

	return (
		<BackupTypeProvider value={{ type, setType }}>
			{type === 'None' && (
				<BackupTypeSelect assetDetails={assetDetails} onClose={onClose} />
			)}
			{type === 'AcronisBackup' && (
				<AcronisBackupSettings
					assetDetails={assetDetails}
					onDestroy={onDestroyAcronis}
					onClose={onClose}
				/>
			)}
			{type === 'CloudBackup' && (
				<CloudBackupSettings
					assetDetails={assetDetails}
					onDestroy={onDestroyCloudBackup}
					onClose={onClose}
				/>
			)}
		</BackupTypeProvider>
	);
};

export default BackupTypeSwitch;
